import Arrow from "../../assets/images/icons/Icon-Freccia-menu.svg";
import { Link } from "react-router-dom";
import BackIcon from "../_shared/components/BackIcon";
import AppText from "../_shared/components/AppText";
import { useState, useEffect } from "react";
import useRestList from "../_shared/hooks/useRestList";
import { defaultPdfs } from "./defaultPdfs";

import SchedeTecniche from "../../assets/images/SchedeTecniche.png";
import PriceList from "../../assets/images/mountingScheme.png";

import DownloadIcon from "../../assets/images/icons/download_icon.png";
import OpenIcon from "../../assets/images/icons/open_icon.png";
import { Select } from "antd";
import { Option } from "antd/es/mentions";
import SideMenu from "../_shared/components/SideMenu";
import MountingSchemes from "./MountingSchemes";

function Downloads(props) {
  const { setSplash } = props;
  useEffect(() => setSplash(false), []);
  const [selectedMenu, setSelectedMenu] = useState(0);
  const [pdfs] = useRestList("/pdfs");
  const [products] = useRestList("/products");
  const [mountingschemes] = useRestList("/mountingschemes");
  const [MSData, setMSData] = useState();
  const [MSDataFilter, setMSDataFilter] = useState(0);

  const [categories] = useRestList("/categories");

  const [allCategories, setAllCategories] = useState();
  const [allSubCategories, setAllSubCategories] = useState();

  const [data, setData] = useState();

  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedSubCategory, setSelectedSubCategory] = useState();
  const [selectedSubCategoryValue, setSelectedSubCategoryValue] = useState();

  const [loading, setLoading] = useState();

  function getDatA() {
    setData([
      ...(products
        ?.filter((prod) => prod?.pdfDetail)
        ?.filter((prod1) => getParentCategory(prod1)) ?? []),
      ...(categories
        ?.filter((prod) => prod?.pdfDetail)
        ?.filter((cat) => cat?.parentCategory?.id === selectedCategory) ?? []),
    ]);
  }
  useEffect(() => {
    selectedSubCategory
      ? setData([
          ...(products
            ?.filter((prod) => prod?.pdfDetail)
            ?.filter(
              (prod1) =>
                prod1?.category === selectedSubCategory ||
                prod1?.category?.parentCategory === selectedSubCategory
            ) ?? []),

          ...(categories
            ?.filter((prod) => prod?.pdfDetail)
            ?.filter((cat) => cat?.id === selectedSubCategory) ?? []),
        ])
      : selectedCategory
      ? getDatA()
      : products &&
        setData([
          ...(products?.filter((prod) => prod?.pdfDetail) ?? []),
          ...(categories?.filter((prod) => prod?.pdfDetail) ?? []),
        ]);
  }, [products, categories, selectedCategory, selectedSubCategory]);

  // useEffect(() => {
  //   setMSData(mountingschemes);
  // }, [mountingschemes]);

  useEffect(() => {
    setMSData(
      mountingschemes
        ?.filter((x) => x.url)
        ?.map((ms) => {
          return {
            key: ms?.id,
            value: ms?.name?.it + " - " + ms?.name?.en,
            data: ms,
          };
        })
    );

    setMSDataFilter(
      mountingschemes
        ?.filter((x) => !x.parentMS)
        .map((ms) => {
          return {
            key: ms?.id,
            value: ms?.name?.it + " - " + ms?.name?.en,
            data: ms,
          };
        })
    );
    console.log("mountingschemes:", mountingschemes);
  }, [mountingschemes]);

  function getMainCategories() {
    return categories?.filter((main) => !main?.parentCategory);
  }
  function getParentCategory(prod) {
    const parentCat = categories?.find(
      (cat) => cat.id === selectedCategory
    )?.id;
    const cat = categories?.find(
      (cat) => cat.id === prod?.category?.parentCategory
    );

    return cat.parentCategory?.id === parentCat;
  }
  useEffect(() => {
    setCategories();
  }, [categories]);

  function setCategories() {
    const cats = getMainCategories();
    setAllCategories(cats);
  }
  function getSubCategories() {
    const subCategories = [];

    categories
      ?.filter((main) => main?.parentCategory?.id === selectedCategory)
      ?.map((subCategory) =>
        subCategories.push({
          key: subCategory?.id,
          value: subCategory?.name?.it + " - " + subCategory?.name?.en,
        })
      );

    setAllSubCategories(subCategories);
  }

  useEffect(() => {
    selectedCategory && getSubCategories();
  }, [selectedCategory]);

  function donwload(url, name) {
    setLoading(true);
    fetch(url).then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = name;
        alink.click();
        setLoading(false);
      });
    });
  }
  function renderCatalogs() {
    return (
      <div className="rootMenu">
        <SideMenu></SideMenu>
        <div className="rootContent">
          <div className="row">
            <BackIcon></BackIcon>
            <div>
              <AppText bold>Scarica</AppText>
              <AppText light>Downloads</AppText>
            </div>
          </div>

          <div
            className="row"
            style={{ marginLeft: 30, minHeight: "80%", alignContent: "center" }}
          >
            {pdfs?.map((pdf) => (
              <div
                style={styles.pdfCard}
                onClick={() => donwload(pdf?.url, pdf?.name?.it)}
              >
                <img
                  alt=""
                  src={pdf?.image}
                  style={{ height: 300, width: 200, objectFit: "contain" }}
                ></img>
                <div className="row">
                  <img
                    alt=""
                    src={DownloadIcon}
                    style={{
                      marginTop: 6,
                      height: 15,
                      width: 15,
                      marginRight: 4,
                      objectFit: "contain",
                    }}
                  ></img>
                  <div>
                    <AppText small bold>
                      {" "}
                      {pdf?.name?.it}
                    </AppText>
                    <AppText small light>
                      {pdf?.name?.en}
                    </AppText>
                  </div>
                </div>
              </div>
            ))}
            {defaultPdfs?.map((pdf) => (
              <div
                style={styles.pdfCard}
                onClick={() => setSelectedMenu(pdf.id)}
              >
                <img
                  alt=""
                  src={pdf?.id === 1 ? SchedeTecniche : PriceList}
                  style={{ height: 300, width: 200, objectFit: "contain" }}
                ></img>
                <div className="row">
                  <img
                    alt=""
                    src={OpenIcon}
                    style={{
                      marginTop: 6,
                      height: 15,
                      width: 15,
                      marginRight: 4,
                      objectFit: "contain",
                    }}
                  ></img>
                  <div>
                    <AppText small bold>
                      {" "}
                      {pdf?.name?.it}
                    </AppText>
                    <AppText small light>
                      {pdf?.name?.en}
                    </AppText>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
  //#region PDFS
  function setAndReset(value, key) {
    setSelectedCategory(key?.key);
    setSelectedSubCategoryValue();
    setSelectedSubCategory(null);
    setAllSubCategories(null);
  }
  function setAndResetSub(value, key) {
    setSelectedSubCategoryValue(key?.value);
    setSelectedSubCategory(key?.key);
  }

  function renderCategories() {
    return (
      <div className="row" style={{ marginTop: 30 }}>
        <Select
          style={{ width: 400 }}
          showSearch
          placeholder="Tipologia / Type"
          onChange={(value, key) => setAndReset(value, key)}
          filterOption={(input, option) =>
            (option.value ?? "").toLowerCase().includes(input.toLowerCase())
          }
          allowClear
        >
          {allCategories?.map((x) => (
            <Option
              value={x?.name?.it + " - " + x?.name?.en}
              key={x?.id}
            ></Option>
          ))}
        </Select>
      </div>
    );
  }

  function renderSubCategories() {
    return (
      <div className="row" style={{ marginTop: 30 }}>
        <Select
          style={{ paddingLeft: 30, width: 400 }}
          showSearch
          placeholder="Categoria / Category"
          onChange={(value, key) => setAndResetSub(value, key)}
          filterOption={(input, option) =>
            (option.value ?? "").toLowerCase().includes(input.toLowerCase())
          }
          allowClear
          value={selectedSubCategoryValue ?? ""}
        >
          {allSubCategories?.map((x) => (
            <Option value={x?.value} key={x?.key}></Option>
          ))}
        </Select>
      </div>
    );
  }
  function renderPdfs() {
    return (
      <div className="row">
        {data
          ?.filter((prod) => prod?.pdfDetail)
          .reverse()
          .map((x) => (
            <div
              style={styles.pdfCard}
              onClick={() => donwload(x?.pdfDetail, x?.name?.it)}
            >
              <img
                alt=""
                src={x?.pdfImageDetail}
                style={{ height: 240, width: 240, objectFit: "cover" }}
              ></img>
              <div>
                {x?.parentCategory && (
                  <div style={styles.inline}>
                    <AppText small bold>
                      {x?.parentCategory?.name?.it}&nbsp;/&nbsp;
                      {x?.parentCategory?.name?.en}
                    </AppText>
                  </div>
                )}
                {x?.category && (
                  <div style={styles.inline}>
                    <AppText small bold>
                      {x?.category?.name?.it}&nbsp;/&nbsp;
                      {x?.category?.name?.en}
                    </AppText>
                  </div>
                )}
                <div style={styles.inline}>
                  <AppText small light>
                    {x?.name?.it}&nbsp;{x?.name?.en && `/ ${x?.name?.en}`}
                  </AppText>
                </div>
              </div>
            </div>
          ))}
      </div>
    );
  }
  function renderTechnicals() {
    return (
      <div className="rootMenu">
        <SideMenu></SideMenu>
        <div className="rootContent">
          <div>
            <div className="row">
              <BackIcon onClick={() => setSelectedMenu(0)}></BackIcon>
              <div>
                <AppText bold>Schede tecniche</AppText>
                <AppText>Technical data sheets</AppText>
              </div>
            </div>
            <div className="row" style={{ marginBottom: 30, marginLeft: 30 }}>
              {renderCategories()}
              {selectedCategory && renderSubCategories()}
            </div>
            <div className="row" style={{ marginLeft: 30 }}>
              {renderPdfs()}
            </div>
          </div>
        </div>
      </div>
    );
  }
  //#endregion

  function renderMountingScheme() {
    return (
      <MountingSchemes
        setSelectedMenu={setSelectedMenu}
        MSData={MSData}
        mountingschemes={mountingschemes}
        download={donwload}
        MSDataFilter={MSDataFilter}
      />
    );
  }
  return selectedMenu === 0
    ? renderCatalogs()
    : selectedMenu === 1
    ? renderTechnicals()
    : selectedMenu === 2 && renderMountingScheme();
}

export default Downloads;

const styles = {
  inline: {
    display: "flex",
    flexDirection: "row",
  },
  pdfCard: {
    width: 240,
    marginRight: 50,
    marginBottom: 50,
    maxHeight: 350,
    cursor: "pointer",
    // border: "0.1px solid black",
  },
};
